var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.6 63.4",
    style: {
      enableBackground: "new 0 0 69.6 63.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#1D1D1B;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000101067535070945780530000007561027255656994953_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000052071017969305918910000009386219430056425092_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,35.1c3.6,13.2-5.4,22.8-18.6,26.4S17.5,61.3,13.9,48s2.8-31.4,16-35S58.3,21.9,61.9,35.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.3,
    cy: 39.2,
    r: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,40.6c0.3,1-0.3,1.9-1.3,2.2c-1,0.3-1.9-0.3-2.2-1.3c-0.3-1,0.3-1.9,1.3-2.2c0,0,0,0,0,0 C29.1,39.1,30.1,39.7,30.4,40.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8,
    cy: 36.7,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,37.7c0.6,2.3-0.7,4.7-3,5.3s-4.7-0.7-5.3-3l0,0C32,37.6,40.4,35.4,41,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,21.5c0.2-1.7,1.6-2.7,2.8-1c1.2,1.6,1.5,17.5,15.5,3.7c6.6-6.5-5.6-11.3-15.8-16.1 c-3.8-1.8-6.3,0.9-7.5,3.2c-0.9,1.6-1.5,3.3-2,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,31.3c-0.5-1.7,0-5-0.4-3S20.5,49.1,4.5,38c-7.7-5.3-3.1-13,6.2-19.5c3.4-2.4,6.4-0.1,7.9,1.9 c1.1,1.4,2.1,3,2.9,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,44c0,2.6-4.6,5-7.1-3.2c1.4,9-3.6,8.4-4.9,5.8"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    className: "st1",
    width: 16.1,
    height: 6.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogLogo);
export default __webpack_public_path__ + "static/media/dog-logo.500b257b4d0851f64f56c2be78e20e65.svg";
export { ForwardRef as ReactComponent };